import React, { useState, useEffect, useContext, ReactElement } from 'react';
import { Skeleton } from 'antd';
import { useHistory } from 'react-router-dom';
import AuthContext from '@packages/contexts/auth/authContext';

import { Role } from '../../../types/Auth';
import { CLIENT_STATUS } from '../../../types/Client';
import { User } from '../../../types/User';

import ClientFormSection from '../../../components/Client/ClientFormSection';

import { useClientFormContext } from '../ClientFormContext';
import { getAllUsers } from '../utils/getters';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import ClientForm from '../ClientForm';
import { submitClientFactory } from '../utils/submit';
import { FORM_MODE } from '../../../types/Form';

const ClientBaseForm: React.FC = (): React.ReactElement => {
    const { client, formConfig, isLoadingData, reload } = useClientFormContext();
    const { user } = useContext(AuthContext);
    const history = useHistory();

    const [isBaseFormLoadingData, setIsBaseFormLoadingData] = useState<boolean>(false);

    const [users, setUsers] = useState<User[]>([]);

    const getUsers = async (): Promise<void> => {
        try {
            if (user!.role !== Role.StuartStaff && user!.role !== Role.SE) {
                return;
            }

            setIsBaseFormLoadingData(true);
            const allUsers = await getAllUsers();
            setUsers(allUsers);
        } finally {
            setIsBaseFormLoadingData(false);
        }
    };

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm
                        tabIsLoadingData={isBaseFormLoadingData}
                        name="base"
                        submitForm={submitClientFactory(client?.id, formConfig, user, (clientId: number) => {
                            history.push(`/admin/clients/${FORM_MODE.DETAIL}/${clientId}`);
                            reload();
                        })}
                    >
                        {({ form }): ReactElement => (
                            <Skeleton loading={isLoadingData || isBaseFormLoadingData}>
                                <ClientFormSection
                                    formInstance={form}
                                    client={client}
                                    users={users}
                                    isDetailMode={formConfig.isDetailMode}
                                    enableControls={client?.status !== CLIENT_STATUS.DELETED}
                                />
                            </Skeleton>
                        )}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default ClientBaseForm;
